import { render, staticRenderFns } from "./Deductibles.vue?vue&type=template&id=2c8a29fb&scoped=true&"
import script from "./Deductibles.vue?vue&type=script&lang=js&"
export * from "./Deductibles.vue?vue&type=script&lang=js&"
import style0 from "./Deductibles.vue?vue&type=style&index=0&id=2c8a29fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a29fb",
  null
  
)

export default component.exports